import {createDiagnosticSession, is404Title} from '../utils/diagnostics/record.js';

export default defineNuxtPlugin({
	name: 'tzh-diagnostics-client', enforce: 'pre',
	setup(nuxtApp) {
		const router = useRouter();
		const initialId = useState('tzhDiagnosticId');
		const newId = () => globalThis.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`;
		let sent = 0, windowStart = Date.now(), inFlight = false;
		const pending = [];
		function sendNext() {
			if (inFlight || !pending.length) return;
			if (Date.now() - windowStart > 60000) { windowStart = Date.now(); sent = 0; }
			if (sent >= 8) { pending.length = 0; return; }
			const record = pending.shift(); sent++; inFlight = true;
			fetch('/api/diagnostics/error', {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify(record), keepalive: true, credentials: 'omit'})
				.catch(() => {}).finally(() => { inFlight = false; sendNext(); });
		}
		const logger = createDiagnosticSession({
			id: newId(), renderId: initialId.value, path: router.currentRoute.value.path, site:window.location.hostname, source: 'browser', version: useAppConfig().version,
			write(record) {
				// Keep a page report even if its preceding API report is still in flight.
				if (pending.length >= 4) pending.shift();
				pending.push(record); sendNext();
			},
		});
		nuxtApp.provide('diagnostics', logger);
		router.beforeEach((to, from) => { if (to.fullPath !== from.fullPath && from.name) logger.start(newId(), to.path); });
		nuxtApp.hook('app:error', error => logger.page('NuxtError', {status_code: error?.statusCode, message: error?.message, url: error?.url}));
		// Observe only the 404-title signal; general browser errors belong to Sentry.
		const labels = useLabels();
		const inspectTitle = (trigger, data = {}) => {
			try {
				const title = data.page_title || document.title;
				if (!is404Title(title, labels.get('404_title', '404'))) return;
				const template = nuxtApp.$appGlobalData?.template || router.currentRoute.value.meta?.template;
				if (template === 'Error404' || router.currentRoute.value.path === '/404/') return;
				logger.measurement({trigger,title,titleSource:data.page_title ? 'event_payload' : 'document',browserPath:window.location.pathname,body404:document.body?.classList.contains('page-error-404') || false,eventPath:data.page_path || data.page_location,routeTemplate:template});
			} catch {}
		};
		nuxtApp.hook('page:finish', () => inspectTitle('page_finish'));
		nuxtApp.hook('app:mounted', () => {
			inspectTitle('app_mounted');
			const observer = new MutationObserver(() => inspectTitle('title_changed'));
			observer.observe(document.head, {childList:true,subtree:true,characterData:true});
			const unmount = nuxtApp.vueApp.unmount;
			nuxtApp.vueApp.unmount = function(...args) {observer.disconnect(); return unmount.apply(this,args);};
		});
		const hooks = useAppConfig().google?.tracking?.hooks;
		if (hooks?.afterPush) {
			const afterPush = hooks.afterPush;
			hooks.afterPush = function(...args) {
				const result = afterPush.apply(this,args);
				inspectTitle('gtm_after_push',args[0]);
				return result;
			};
		}

	},
});
